import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step", "dot"]

  connect() {
    this.currentStep = 0
    this.updateVisibility()
  }

  advance() {
    if (this.currentStep < this.stepTargets.length - 1) {
      this.currentStep++
      this.updateVisibility()
    }
  }

  updateVisibility() {
    this.stepTargets.forEach((step, index) => {
      step.classList.toggle("hidden", index !== this.currentStep)
    })
    this.dotTargets.forEach((dot, index) => {
      dot.classList.toggle("bg-violet-500", index <= this.currentStep)
      dot.classList.toggle("bg-stone-300", index > this.currentStep)
    })
  }
}
